import { http } from '@/api/http';
import { ApiResponseBody } from '@/api/types';
import { getOpobffUsersApiUrl } from './opobff-users.paths';
import { GetOpoUserOperationParams, InviteOpoUserRequestBody, OpoUserInvitation } from './opobff-users.types';

const inviteUser = async (body: InviteOpoUserRequestBody): Promise<OpoUserInvitation> => {
  const res = await http.post<ApiResponseBody<OpoUserInvitation>>(getOpobffUsersApiUrl.users(), body);
  return res.data.data;
};

const updateUser = async ({
  contactId,
  ...body
}: InviteOpoUserRequestBody & { contactId: string }): Promise<OpoUserInvitation> => {
  const res = await http.patch<ApiResponseBody<OpoUserInvitation>>(getOpobffUsersApiUrl.userById(contactId), body);
  return res.data.data;
};

const getOperation = async (correlationId: string, params?: GetOpoUserOperationParams): Promise<OpoUserInvitation> => {
  const res = await http.get<ApiResponseBody<OpoUserInvitation>>(
    getOpobffUsersApiUrl.operationByCorrelationId(correlationId),
    { params },
  );
  return res.data.data;
};

export const opobffUsersApiFetcher = {
  inviteUser,
  updateUser,
  getOperation,
};
